@use "~theme/breakpoints";

.compactContainer {
  align-items: center;
  background: var(--white);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
}

.compactOfficeName {
  color: var(--blue-01);
  font-size: 12px;
  font-weight: 600;
}

.compactAction {
  color: var(--blue-01);
  font-size: 11px;
  text-decoration: underline;
}

.compactActionIcon {
  height: 12px;
  margin-right: 4px;
  width: 12px;
}
.container {
    max-width: 100%;
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #40668C;
    box-shadow: 0px 2px 6px #eaeaea;
    border-radius: 4px;
    overflow:auto;
    @include breakpoints.desktop {
        border-bottom: none;
        border-radius: 4px 4px 0px 0px;
    }
}

.footerPhoneLink {
    white-space: nowrap;
}
.moveTop {
    top: 5%;
}

.headerSection {
    border-bottom: 0.5px solid #40668C;
    height:35px;
    text-transform: uppercase;
    padding-top: 5px;
}

.heading {
    color: #003366;
    float: left;
    width:80%;
    padding: 1px 0px 0px 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #003366;
    @include breakpoints.desktop {
        font-size: 12px; 
        width:74%;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:80%;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
        width:80%;
    }
}

.action {
    color: #003366;
    float:right;
    width:20%;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
    @include breakpoints.desktop {
        font-size: 12px; 
        width:26%;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:20%;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
        width:20%;
    }
}

.contentSection {
    padding: 10px;
    height: auto;
    display: block;
    overflow: auto;
}

.contentLeft {
    float:left;
    width: 60%;
}

.contentRight {
    float:right;
    width:40%;
    text-align: right;
}

.officeName {
    font-size: 16px;
    color: black;
    font-weight: 600;
    @include breakpoints.desktop {
        font-size: 14px;
    }
    @include breakpoints.desktop-medium {
        font-size: 15px;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
    }
}

.officeAddress {
    color: rgba(0, 0, 0, 0.7);
    font-size: 14px;
    font-weight: 400;
    @include breakpoints.desktop {
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 13px;
    }
    @include breakpoints.desktop-large {
        font-size: 14px; 
    }
}

.officePhone {
    color: #003366;
    font-size: 12px;
    font-weight: 400;
}

.icon {
    margin-right: 5px;
}

.medicaid {
    color: #003366;
    font-size: 10px;
    font-weight: 400;
}

.boldUnderline {
    text-decoration-line: underline;
    font-weight: 700;
}

.timings {
    color: #003366;
    font-size: 12px;
    font-weight: 400;
}
